
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref85b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref85b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hS6sa", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $d02c7c5283a16a22$export$6503ec6e8aabbaf; }, function (v) { return $d02c7c5283a16a22$export$6503ec6e8aabbaf = v; });
var $d02c7c5283a16a22$export$6503ec6e8aabbaf;
var $d02c7c5283a16a22$export$f7ad0328861e2f03;
"use strict";
var $d02c7c5283a16a22$var$mapping = new Map();
function $d02c7c5283a16a22$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$d02c7c5283a16a22$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $d02c7c5283a16a22$var$resolve(id) {
    var resolved = $d02c7c5283a16a22$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$d02c7c5283a16a22$export$6503ec6e8aabbaf = $d02c7c5283a16a22$var$register;
$d02c7c5283a16a22$export$f7ad0328861e2f03 = $d02c7c5283a16a22$var$resolve;

});

parcelRegister("iKXx1", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $da7ab3960c3950b9$export$bdfd709ae4826697; }, function (v) { return $da7ab3960c3950b9$export$bdfd709ae4826697 = v; });
var $da7ab3960c3950b9$export$bdfd709ae4826697;
var $da7ab3960c3950b9$export$c9e73fbda7da57b6;
var $da7ab3960c3950b9$export$5a759dc7a1cfb72a;
"use strict";
var $da7ab3960c3950b9$var$bundleURL = {};
function $da7ab3960c3950b9$var$getBundleURLCached(id) {
    var value = $da7ab3960c3950b9$var$bundleURL[id];
    if (!value) {
        value = $da7ab3960c3950b9$var$getBundleURL();
        $da7ab3960c3950b9$var$bundleURL[id] = value;
    }
    return value;
}
function $da7ab3960c3950b9$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $da7ab3960c3950b9$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $da7ab3960c3950b9$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $da7ab3960c3950b9$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$da7ab3960c3950b9$export$bdfd709ae4826697 = $da7ab3960c3950b9$var$getBundleURLCached;
$da7ab3960c3950b9$export$c9e73fbda7da57b6 = $da7ab3960c3950b9$var$getBaseURL;
$da7ab3960c3950b9$export$5a759dc7a1cfb72a = $da7ab3960c3950b9$var$getOrigin;

});

parcelRegister("1K4o4", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $144d7d87acaa8950$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $144d7d87acaa8950$export$f3b8ed2e4a5d10b8; });
function $144d7d87acaa8950$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("5kWiG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3e2c0b3c34a727d3$export$2996f80ef42b8419; });
function $3e2c0b3c34a727d3$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hHaEF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ce1eb7a7847cf6d4$export$d60067ff2358eee8; });
function $ce1eb7a7847cf6d4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ce1eb7a7847cf6d4$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $ce1eb7a7847cf6d4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ce1eb7a7847cf6d4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("dACZV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9e4ce34f355067d5$export$7e4530ad35d3bb8; });

var $aLByk = parcelRequire("aLByk");
function $9e4ce34f355067d5$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $aLByk._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("aLByk", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $7d6b6c53d019132a$export$c2c98ac76e997b63; });
function $7d6b6c53d019132a$export$c2c98ac76e997b63(o, p) {
    $7d6b6c53d019132a$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7d6b6c53d019132a$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("jhb1H", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e0882876d2049d71$export$8dd05c13f5255580; });

var $8wb0B = parcelRequire("8wb0B");

var $drer0 = parcelRequire("drer0");

var $9WH53 = parcelRequire("9WH53");
function $e0882876d2049d71$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $drer0._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $8wb0B._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $8wb0B._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9WH53._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("8wb0B", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $6339da03daa44400$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $6339da03daa44400$export$f09211a7d3c496a1; });
function $6339da03daa44400$export$f09211a7d3c496a1(o) {
    $6339da03daa44400$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6339da03daa44400$export$f09211a7d3c496a1(o);
}

});

parcelRegister("drer0", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $9c88fe61dc568c9c$export$685354647fba1516; });
function $9c88fe61dc568c9c$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("9WH53", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $73daf2b96360aece$export$ef97c660ca164e52; });

var $1K4o4 = parcelRequire("1K4o4");

var $2lB2g = parcelRequire("2lB2g");
function $73daf2b96360aece$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $2lB2g._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $1K4o4._assert_this_initialized)(self);
}

});


parcelRegister("ev0Km", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8e48a38ea1e4026$export$2e2bcd8739ae039; });

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $dACZV = parcelRequire("dACZV");

var $jhb1H = parcelRequire("jhb1H");

var $2B8he = parcelRequire("2B8he");
var $a8e48a38ea1e4026$var$previewView = /*#__PURE__*/ function(appView) {
    "use strict";
    (0, $dACZV._)(previewView, appView);
    var _super = (0, $jhb1H._)(previewView);
    function previewView() {
        (0, $5kWiG._)(this, previewView);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(previewView, [
        {
            key: "notesMarkup",
            value: function notesMarkup(data, options) {
                return '\n          <div class="note-item all-notes '.concat(data.tag, " ").concat(options.favorite, '" data-id="').concat(data.id, '" data-favorited="').concat(data.favorited, '">\n            <div class="note-inner-content">\n              <div class="note-content">\n                <p class="note-title" data-noteTitle="').concat(data.title, '">\n                  ').concat(options.limitTitle, '\n                </p>\n                <p class="meta-time">\n                 ').concat(options.edited, " ").concat(options.newDate, '\n                </p>\n                <div class="note-description-content">\n                  <p class="note-description" data-noteDescription="').concat(data.description, '">\n                    ').concat(options.limitDescription, '\n                  </p>\n                </div>\n              </div>\n              <div class="note-action">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star fav-note">\n                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>\n                </svg>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 delete-note">\n                  <polyline points="3 6 5 6 21 6"></polyline>\n                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>\n                  <line x1="10" y1="11" x2="10" y2="17"></line>\n                  <line x1="14" y1="11" x2="14" y2="17"></line>\n                </svg>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 edit-note"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>\n              </div>\n              <div class="note-footer">\n                <div class="tags-selector btn-group">\n                  <a class="nav-link dropdown-toggle d-icon label-group" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="true">\n                    <span>\n                      <div class="tags">\n                        <div class="g-dot-personal"></div>\n                        <div class="g-dot-work"></div>\n                        <div class="g-dot-social"></div>\n                        <div class="g-dot-important"></div>\n                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical">\n                          <circle cx="12" cy="12" r="1"></circle>\n                          <circle cx="12" cy="5" r="1"></circle>\n                          <circle cx="12" cy="19" r="1"></circle>\n                        </svg>\n                      </div>\n                    </span>\n                  </a>\n                  <div class="dropdown-menu dropdown-menu-right d-icon-menu">\n                    <a class="note-personal label-group-item label-personal dropdown-item position-relative g-dot-personal" href="javascript:void(0);"> Personal</a>\n                    <a class="note-work label-group-item label-work dropdown-item position-relative g-dot-work" href="javascript:void(0);"> Work</a>\n                    <a class="note-social label-group-item label-social dropdown-item position-relative g-dot-social" href="javascript:void(0);"> Social</a>\n                    <a class="note-important label-group-item label-important dropdown-item position-relative g-dot-important" href="javascript:void(0);"> Important</a>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        ');
            }
        },
        {
            key: "todoMarkup",
            value: function todoMarkup(data, options) {
                return '\n      <div class="todo-item '.concat(data.trash ? "" : "all-list", " ").concat(options.important, " ").concat(options.completed, " ").concat(options.trash, '" data-id="').concat(data.id, '" data-completed="').concat(data.completed, '" data-trash="').concat(data.trash, '"\n      data-important="').concat(data.important, '" data-priority="').concat(data.priority, '">\n        <div class="todo-item-inner">\n          <div class="n-chk text-center">\n            <div class="form-check form-check-primary form-check-inline mt-1 me-0" data-bs-toggle="collapse" data-bs-target="">\n              <input class="form-check-input inbox-chkbox" type="checkbox" ').concat(data.completed ? "checked" : "", '>\n            </div>\n          </div>\n\n          <div class="todo-content">\n            <h5 class="todo-heading" data-todoheading="').concat(data.title, '">\n             ').concat(options.limitTitle, '\n            </h5>\n            <p class="todo-text" data-todohtml="').concat(data.description, '" data-todotext="').concat(data.description, '">\n              ').concat(data.description, '\n            </p>\n          </div>\n\n          <div class="meta-frame">\n            <p class="meta-time todo-time">').concat(options.isCompleted, " ").concat(options.edited, " ").concat(options.newDate, '</p>\n          </div>\n\n          <div class="priority-dropdown custom-dropdown-icon">\n            <div class="dropdown p-dropdown">\n              <a class="dropdown-toggle ').concat(data.priority, '" href="#" role="button" id="dropdownMenuLink-1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                  <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                  <line x1="12" y1="8" x2="12" y2="12"></line>\n                  <line x1="12" y1="16" x2="12" y2="16"></line>\n                </svg>\n              </a>\n\n              <div class="dropdown-menu left" aria-labelledby="dropdownMenuLink-1">\n                <a class="danger dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  High</a>\n                <a class="warning dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  Middle</a>\n                <a class="primary dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  Low</a>\n              </div>\n            </div>\n          </div>\n\n          <div class="action-dropdown custom-dropdown-icon">\n            <div class="dropdown">\n              <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical">\n                  <circle cx="12" cy="12" r="1"></circle>\n                  <circle cx="12" cy="5" r="1"></circle>\n                  <circle cx="12" cy="19" r="1"></circle>\n                </svg>\n              </a>\n\n              <div class="dropdown-menu left" aria-labelledby="dropdownMenuLink-2">\n                <a class="edit dropdown-item" href="javascript:void(0);">Edit</a>\n                <a class="important dropdown-item" href="javascript:void(0);">').concat(data.important === 1 ? "Mark as Normal" : "Mark as Important", '</a>\n                <a class="dropdown-item delete" href="javascript:void(0);">Delete</a>\n                <a class="dropdown-item permanent-delete" href="javascript:void(0);">Permanent Delete</a>\n                <a class="dropdown-item revive" href="javascript:void(0);">Revive Task</a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    ');
            }
        },
        {
            key: "scrumBoardMarkup",
            value: function scrumBoardMarkup(data) {
                return '\n        <div data-draggable="true" data-list-id="'.concat(data.tasksection, '" data-card-id="').concat(data.id, '" data-order="').concat(data.order, '" class="card task-text-progress" style="">\n          <div class="card-body">\n            <div class="task-header">\n              <div>\n                <h4 class="" data-taskTitle="').concat(data.title, '">').concat(data.title, '</h4>\n              </div>\n              <div>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 s-task-edit">\n                  <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>\n                </svg>\n              </div>\n            </div>\n            <div class="task-body">\n              <div class="task-content">\n                <p class="" data-taskText="').concat(data.description, '">').concat(data.description, '</p>\n                <div class="').concat(data.progress ? "" : "progress-none-bar d-none", '">\n                    <div class="progress br-30">\n                      <div class="progress-bar bg-success" role="progressbar" data-progressstate="').concat(data.progress, '" style="width: ').concat(data.progress, '%" aria-valuenow="').concat(data.progress, '" aria-valuemin="0" aria-valuemax="100">\n                      </div>\n                    </div>\n                    <p class="progress-count">').concat(data.progress, '%</p>\n                </div>\n              </div>\n              <div class="task-bottom">\n                <div class="tb-section-1">\n                  <span data-taskDate="').concat(data.date, '">\n                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar">\n                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>\n                      <line x1="16" y1="2" x2="16" y2="6"></line>\n                      <line x1="8" y1="2" x2="8" y2="6"></line>\n                      <line x1="3" y1="10" x2="21" y2="10"></line>\n                    </svg>\n                    ').concat(data.date, '\n                  </span>\n                </div>\n                <div class="tb-section-2">\n                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 s-task-delete">\n                    <polyline points="3 6 5 6 21 6"></polyline>\n                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>\n                    <line x1="10" y1="11" x2="10" y2="17"></line>\n                    <line x1="14" y1="11" x2="14" y2="17"></line>\n                  </svg>\n                </div>\n              </div>\n            </div>\n          </div>');
            }
        },
        {
            key: "scrumListMarkup",
            value: function scrumListMarkup(data) {
                return '\n    <div data-section="'.concat(data.id, '" data-order="').concat(data.order, '" class="task-list-container mb-4 " data-connect="sorting">\n      <div class="connect-sorting">\n        <div class="task-container-header">\n          <h6 class="s-heading" data-listTitle="').concat(data.title, '">\n            ').concat(data.title, '\n          </h6>\n          <div class="dropdown">\n            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink-4" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">\n                <circle cx="12" cy="12" r="1"></circle>\n                <circle cx="19" cy="12" r="1"></circle>\n                <circle cx="5" cy="12" r="1"></circle>\n              </svg>\n            </a>\n            <div class="dropdown-menu dropdown-menu-right left" aria-labelledby="dropdownMenuLink-4">\n              <a class="dropdown-item list-edit" href="javascript:void(0);">Edit List</a>\n              <a class="dropdown-item list-delete" href="javascript:void(0);">Delete List</a>\n              <a class="dropdown-item list-clear-all" href="javascript:void(0);">Clear All Cards</a>\n            </div>\n          </div>\n        </div>\n        <div class="connect-sorting-content" data-sortable="true">\n        </div>\n        <div class="add-s-task">\n          <a class="addTask">\n            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle">\n              <circle cx="12" cy="12" r="10"></circle>\n              <line x1="12" y1="8" x2="12" y2="16"></line>\n              <line x1="8" y1="12" x2="16" y2="12"></line>\n            </svg>\n            Add Task\n          </a>\n        </div>\n      </div>\n    </div>\n  ');
            }
        },
        {
            key: "timeLineMarkup",
            value: function timeLineMarkup(data, timeFormat) {
                return '\n          <div class="item-timeline">\n            <p class="t-time">'.concat(timeFormat.timeDigits, '</p>\n            <div class="t-dot t-dot-').concat(data.tag, '"></div>\n            <div class="t-text">\n              <p>').concat(data.title, '</p>\n              <p class="t-meta-time">').concat(timeFormat.timeAgo, "</p>\n              ").concat(data.startdate ? '<p class="t-meta-time event-time"> '.concat(data.startdate, "</p>") : "", "\n            </div>\n          </div>\n    ");
            }
        }
    ]);
    return previewView;
}((0, $2B8he.default));
var $a8e48a38ea1e4026$export$2e2bcd8739ae039 = new $a8e48a38ea1e4026$var$previewView();

});
parcelRegister("2B8he", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e45751d69314b77$export$2e2bcd8739ae039; });

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $8EGc6 = parcelRequire("8EGc6");

var $iFe8d = parcelRequire("iFe8d");

var $4HRPq = parcelRequire("4HRPq");

var $1e45751d69314b77$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function appView() {
        (0, $5kWiG._)(this, appView);
        (0, $8EGc6._)(this, "_noteContainer", document.querySelector("#ct"));
        (0, $8EGc6._)(this, "_data", void 0);
    }
    (0, $hHaEF._)(appView, [
        {
            key: "openModal",
            value: function openModal(element) {
                $(element).modal("show");
                $("#btn-n-save").hide();
                $("#btn-n-add").show();
            }
        },
        {
            key: "showContentModal",
            value: function showContentModal(title, description, element) {
                document.querySelector(".task-heading").textContent = title;
                document.querySelector(".task-text").innerHTML = description;
                $(element).modal("show");
            }
        },
        {
            key: "successMessageInfo",
            value: function successMessageInfo(message) {
                var notyf = new (0, $iFe8d.Notyf)((0, $4HRPq.INOTIFYOPTIONS));
                notyf.success(message);
            }
        },
        {
            key: "failedMessageInfo",
            value: function failedMessageInfo(message) {
                var notyf = new (0, $iFe8d.Notyf)((0, $4HRPq.INOTIFYOPTIONS));
                notyf.error(message);
            }
        },
        {
            key: "closeModal",
            value: function closeModal(element, message) {
                var info = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                info ? this.successMessageInfo(message) : this.failedMessageInfo(message);
                $(element).modal("hide");
            }
        },
        {
            key: "formatDate",
            value: function formatDate(date) {
                var newDate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var locale = navigator.language;
                var calcDayPassed = function(date1, date2) {
                    return Math.round(Math.abs(date2 - date1) / 86400000);
                };
                var formatSingleDate = function(dateElement) {
                    var newDate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var dateStr = newDate ? dateElement : dateElement.textContent;
                    var dayPassed = calcDayPassed(new Date(), new Date(dateStr));
                    if (dayPassed === 0) return "Today";
                    if (dayPassed === 1) return "Yesterday";
                    if (dayPassed <= 7) return "".concat(dayPassed, " days ago");
                    return new Intl.DateTimeFormat(locale).format(new Date(dateStr));
                };
                if (newDate) {
                    var formattedDate = formatSingleDate(date, true);
                    return formattedDate;
                } else {
                    var dateElements = document.querySelectorAll(".meta-time");
                    if (dateElements) dateElements.forEach(function(dateElement) {
                        var formattedDate = formatSingleDate(dateElement);
                        dateElement.textContent = formattedDate;
                    });
                }
            }
        },
        {
            // renderErrorMessage(message = this._errorMsg) {
            //   if (!this._parentElement) return;
            //   const markup = `
            //     <div class="col-12 empty-note">
            //       <div class="alert alert-background alert-dismissible fade show mb-4" role="alert">
            //           <strong>${message}</strong>
            //       </div>
            //     </div>
            //   `;
            //   this._parentElement.insertAdjacentHTML('afterbegin', markup);
            // }
            key: "renderErrorMessage",
            value: function renderErrorMessage() {
                var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._errorMsg;
                if (!this._parentElement) return;
                var markup = '\n      <div class="col-12 empty-note">\n        <div class="alert alert-background alert-dismissible fade show mb-4" role="alert">\n            <strong>'.concat(message, "</strong>\n        </div>\n      </div>\n    ");
                var searchEl = this._parentElement.querySelector(".search");
                searchEl.insertAdjacentHTML("afterend", markup);
            }
        },
        {
            key: "removeEmptyContainer",
            value: function removeEmptyContainer() {
                var emptyNote = document.querySelector(".empty-note");
                if (!emptyNote) return;
                if (emptyNote) emptyNote.remove();
            }
        },
        {
            key: "limitCharacters",
            value: function limitCharacters(inputString, limit) {
                if (inputString.length <= limit) return inputString;
                else return inputString.substring(0, limit) + "...";
            }
        },
        {
            key: "update",
            value: function update(data, markup, containerElement) {
                this._data = data;
                var newMarkup = markup;
                var newDOM = document.createRange().createContextualFragment(newMarkup);
                var newElement = newDOM.querySelector(this._containterItem);
                var curHTML = containerElement.innerHTML;
                var newHTML = newElement.innerHTML;
                if (curHTML !== newHTML) containerElement.innerHTML = newHTML;
            }
        },
        {
            key: "sortDataByTimestamp",
            value: function sortDataByTimestamp(data) {
                return data.sort(function(a, b) {
                    return a.timestamp - b.timestamp;
                });
            }
        },
        {
            // getElementsByAttribute(attributeName, attributeValue) {
            //   const selector = `[data-${attributeName}="${attributeValue}"]`;
            //   return document.querySelectorAll(selector);
            // }
            key: "getElementsByAttribute",
            value: function getElementsByAttribute(attributeName, attributeValue, excludedClass) {
                var selector = "[data-".concat(attributeName, '="').concat(attributeValue, '"]:not(.').concat(excludedClass, ")");
                return document.querySelectorAll(selector);
            }
        },
        {
            key: "toggleMenuViews",
            value: function toggleMenuViews() {
                var _this = this;
                var self = this;
                this._listBtns.forEach(function(btn) {
                    btn.addEventListener("click", (function() {
                        var btnId = btn.id;
                        var elementsToShow;
                        if ([
                            "warning",
                            "danger",
                            "primary"
                        ].includes(btn.id)) elementsToShow = self.getElementsByAttribute("priority", btnId, "todo-task-trash");
                        else elementsToShow = document.querySelectorAll("." + btnId);
                        var elementsArray = Array.from(elementsToShow);
                        elementsArray.forEach(function(el) {
                            el.classList.add("fade-in");
                            el.style.display = "block";
                            setTimeout(function() {
                                el.classList.remove("fade-in");
                            }, 300);
                        });
                        var allElements = document.querySelectorAll("#ct > div");
                        allElements.forEach(function(el) {
                            if (!elementsArray.includes(el)) el.style.display = "none";
                        });
                        this._listBtns.forEach(function(btn) {
                            return btn.classList.remove("active");
                        });
                        btn.classList.add("active");
                    }).bind(_this));
                });
            }
        },
        {
            key: "validateInput",
            value: function validateInput(validationField, titleInput, descriptionInput) {
                var isValid = true;
                if (titleInput) {
                    var titleInputValue = titleInput.value;
                    if (titleInputValue === "") {
                        validationField[0].innerHTML = "Title Required";
                        validationField[0].style.display = "block";
                        isValid = false;
                    } else if (titleInputValue.length > this._titleMaxLength) {
                        validationField[0].innerHTML = "Max Length is ".concat(this._titleMaxLength.toString(), " characters");
                        validationField[0].style.display = "block";
                        isValid = false;
                    } else validationField[0].style.display = "none";
                }
                if (descriptionInput) {
                    var descriptionInputValue = this._isQuill ? this._quill.getText().trim() : descriptionInput.value;
                    if (descriptionInputValue === "") {
                        validationField[1].innerHTML = "Description Required";
                        validationField[1].style.display = "block";
                        isValid = false;
                    } else if (descriptionInputValue.length > this._descriptionMaxLength) {
                        validationField[1].innerHTML = "Max Length is ".concat(this._descriptionMaxLength.toString(), " characters");
                        validationField[1].style.display = "block";
                        isValid = false;
                    } else validationField[1].style.display = "none";
                }
                return isValid;
            }
        },
        {
            key: "openNoteModal",
            value: function openNoteModal(element, title, description) {
                this.openModal(element);
                title = document.querySelector("#n-title");
                title.setAttribute("maxlength", this._titleMaxLength.toString());
                description = document.querySelector("#n-description");
                description.setAttribute("maxlength", this._descriptionMaxLength.toString());
            }
        },
        {
            key: "_searchLists",
            value: function _searchLists(element) {
                document.querySelector(".input-search").addEventListener("keyup", function() {
                    var searchTerm = this.value.toLowerCase();
                    var todoItems = element;
                    todoItems.forEach(function(item) {
                        var itemText = item.textContent.toLowerCase();
                        if (itemText.includes(searchTerm)) item.style.display = "block";
                        else item.style.display = "none";
                    });
                });
            }
        },
        {
            key: "formatTime",
            value: function formatTime(timestamp) {
                var date = new Date(timestamp);
                var timeOptions = {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false
                };
                return new Intl.DateTimeFormat("en-US", timeOptions).format(date);
            }
        },
        {
            key: "relativeTime",
            value: function relativeTime(timestamp) {
                var now = new Date();
                var timeDifference = now - timestamp;
                var minutesDifference = Math.floor(timeDifference / 60000);
                var hoursDifference = Math.floor(timeDifference / 3600000);
                if (minutesDifference < 1) return "Just now";
                else if (minutesDifference < 60) return "".concat(minutesDifference, " minute").concat(minutesDifference > 1 ? "s" : "", " ago");
                else if (hoursDifference < 24) return "".concat(hoursDifference, " hour").concat(hoursDifference > 1 ? "s" : "", " ago");
                else return this.formatTime(timestamp);
            }
        }
    ]);
    return appView;
}();

});
parcelRegister("iFe8d", function(module, exports) {

$parcel$export(module.exports, "Notyf", function () { return $0381a95d2c185104$export$146ebdf5fc143718; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $0381a95d2c185104$var$__assign = function __assign1() {
    $0381a95d2c185104$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0381a95d2c185104$var$__assign.apply(this, arguments);
};
var $0381a95d2c185104$export$1efaef7de3802058 = /** @class */ function() {
    function NotyfNotification(options) {
        this.options = options;
        this.listeners = {};
    }
    NotyfNotification.prototype.on = function(eventType, cb) {
        var callbacks = this.listeners[eventType] || [];
        this.listeners[eventType] = callbacks.concat([
            cb
        ]);
    };
    NotyfNotification.prototype.triggerEvent = function(eventType, event) {
        var _this = this;
        var callbacks = this.listeners[eventType] || [];
        callbacks.forEach(function(cb) {
            return cb({
                target: _this,
                event: event
            });
        });
    };
    return NotyfNotification;
}();
var $0381a95d2c185104$export$2324fc501d2ffc65;
(function(NotyfArrayEvent) {
    NotyfArrayEvent[NotyfArrayEvent["Add"] = 0] = "Add";
    NotyfArrayEvent[NotyfArrayEvent["Remove"] = 1] = "Remove";
})($0381a95d2c185104$export$2324fc501d2ffc65 || ($0381a95d2c185104$export$2324fc501d2ffc65 = {}));
var $0381a95d2c185104$export$7763ebb8bf460cea = /** @class */ function() {
    function NotyfArray() {
        this.notifications = [];
    }
    NotyfArray.prototype.push = function(elem) {
        this.notifications.push(elem);
        this.updateFn(elem, $0381a95d2c185104$export$2324fc501d2ffc65.Add, this.notifications);
    };
    NotyfArray.prototype.splice = function(index, num) {
        var elem = this.notifications.splice(index, num)[0];
        this.updateFn(elem, $0381a95d2c185104$export$2324fc501d2ffc65.Remove, this.notifications);
        return elem;
    };
    NotyfArray.prototype.indexOf = function(elem) {
        return this.notifications.indexOf(elem);
    };
    NotyfArray.prototype.onUpdate = function(fn) {
        this.updateFn = fn;
    };
    return NotyfArray;
}();
var $0381a95d2c185104$export$776308576d349339;
(function(NotyfEvent) {
    NotyfEvent["Dismiss"] = "dismiss";
    NotyfEvent["Click"] = "click";
})($0381a95d2c185104$export$776308576d349339 || ($0381a95d2c185104$export$776308576d349339 = {}));
var $0381a95d2c185104$export$93ca5d3f8675ae4c = {
    types: [
        {
            type: "success",
            className: "notyf__toast--success",
            backgroundColor: "#3dc763",
            icon: {
                className: "notyf__icon--success",
                tagName: "i"
            }
        },
        {
            type: "error",
            className: "notyf__toast--error",
            backgroundColor: "#ed3d3d",
            icon: {
                className: "notyf__icon--error",
                tagName: "i"
            }
        }
    ],
    duration: 2000,
    ripple: true,
    position: {
        x: "right",
        y: "bottom"
    },
    dismissible: false
};
var $0381a95d2c185104$export$75d30b0f81ca0e5f = /** @class */ function() {
    function NotyfView() {
        this.notifications = [];
        this.events = {};
        this.X_POSITION_FLEX_MAP = {
            left: "flex-start",
            center: "center",
            right: "flex-end"
        };
        this.Y_POSITION_FLEX_MAP = {
            top: "flex-start",
            center: "center",
            bottom: "flex-end"
        };
        // Creates the main notifications container
        var docFrag = document.createDocumentFragment();
        var notyfContainer = this._createHTMLElement({
            tagName: "div",
            className: "notyf"
        });
        docFrag.appendChild(notyfContainer);
        document.body.appendChild(docFrag);
        this.container = notyfContainer;
        // Identifies the main animation end event
        this.animationEndEventName = this._getAnimationEndEventName();
        this._createA11yContainer();
    }
    NotyfView.prototype.on = function(event, cb) {
        var _a;
        this.events = $0381a95d2c185104$var$__assign($0381a95d2c185104$var$__assign({}, this.events), (_a = {}, _a[event] = cb, _a));
    };
    NotyfView.prototype.update = function(notification, type) {
        if (type === $0381a95d2c185104$export$2324fc501d2ffc65.Add) this.addNotification(notification);
        else if (type === $0381a95d2c185104$export$2324fc501d2ffc65.Remove) this.removeNotification(notification);
    };
    NotyfView.prototype.removeNotification = function(notification) {
        var _this = this;
        var renderedNotification = this._popRenderedNotification(notification);
        var node;
        if (!renderedNotification) return;
        node = renderedNotification.node;
        node.classList.add("notyf__toast--disappear");
        var handleEvent;
        node.addEventListener(this.animationEndEventName, handleEvent = function(event) {
            if (event.target === node) {
                node.removeEventListener(_this.animationEndEventName, handleEvent);
                _this.container.removeChild(node);
            }
        });
    };
    NotyfView.prototype.addNotification = function(notification) {
        var node = this._renderNotification(notification);
        this.notifications.push({
            notification: notification,
            node: node
        });
        // For a11y purposes, we still want to announce that there's a notification in the screen
        // even if it comes with no message.
        this._announce(notification.options.message || "Notification");
    };
    NotyfView.prototype._renderNotification = function(notification) {
        var _a;
        var card = this._buildNotificationCard(notification);
        var className = notification.options.className;
        if (className) (_a = card.classList).add.apply(_a, className.split(" "));
        this.container.appendChild(card);
        return card;
    };
    NotyfView.prototype._popRenderedNotification = function(notification) {
        var idx = -1;
        for(var i = 0; i < this.notifications.length && idx < 0; i++)if (this.notifications[i].notification === notification) idx = i;
        if (idx !== -1) return this.notifications.splice(idx, 1)[0];
        return;
    };
    NotyfView.prototype.getXPosition = function(options) {
        var _a;
        return ((_a = options === null || options === void 0 ? void 0 : options.position) === null || _a === void 0 ? void 0 : _a.x) || "right";
    };
    NotyfView.prototype.getYPosition = function(options) {
        var _a;
        return ((_a = options === null || options === void 0 ? void 0 : options.position) === null || _a === void 0 ? void 0 : _a.y) || "bottom";
    };
    NotyfView.prototype.adjustContainerAlignment = function(options) {
        var align = this.X_POSITION_FLEX_MAP[this.getXPosition(options)];
        var justify = this.Y_POSITION_FLEX_MAP[this.getYPosition(options)];
        var style = this.container.style;
        style.setProperty("justify-content", justify);
        style.setProperty("align-items", align);
    };
    NotyfView.prototype._buildNotificationCard = function(notification) {
        var _this = this;
        var options = notification.options;
        var iconOpts = options.icon;
        // Adjust container according to position (e.g. top-left, bottom-center, etc)
        this.adjustContainerAlignment(options);
        // Create elements
        var notificationElem = this._createHTMLElement({
            tagName: "div",
            className: "notyf__toast"
        });
        var ripple = this._createHTMLElement({
            tagName: "div",
            className: "notyf__ripple"
        });
        var wrapper = this._createHTMLElement({
            tagName: "div",
            className: "notyf__wrapper"
        });
        var message = this._createHTMLElement({
            tagName: "div",
            className: "notyf__message"
        });
        message.innerHTML = options.message || "";
        var mainColor = options.background || options.backgroundColor;
        // Build the icon and append it to the card
        if (iconOpts) {
            var iconContainer = this._createHTMLElement({
                tagName: "div",
                className: "notyf__icon"
            });
            if (typeof iconOpts === "string" || iconOpts instanceof String) iconContainer.innerHTML = new String(iconOpts).valueOf();
            if (typeof iconOpts === "object") {
                var _a = iconOpts.tagName, tagName = _a === void 0 ? "i" : _a, className_1 = iconOpts.className, text = iconOpts.text, _b = iconOpts.color, color = _b === void 0 ? mainColor : _b;
                var iconElement = this._createHTMLElement({
                    tagName: tagName,
                    className: className_1,
                    text: text
                });
                if (color) iconElement.style.color = color;
                iconContainer.appendChild(iconElement);
            }
            wrapper.appendChild(iconContainer);
        }
        wrapper.appendChild(message);
        notificationElem.appendChild(wrapper);
        // Add ripple if applicable, else just paint the full toast
        if (mainColor) {
            if (options.ripple) {
                ripple.style.background = mainColor;
                notificationElem.appendChild(ripple);
            } else notificationElem.style.background = mainColor;
        }
        // Add dismiss button
        if (options.dismissible) {
            var dismissWrapper = this._createHTMLElement({
                tagName: "div",
                className: "notyf__dismiss"
            });
            var dismissButton = this._createHTMLElement({
                tagName: "button",
                className: "notyf__dismiss-btn"
            });
            dismissWrapper.appendChild(dismissButton);
            wrapper.appendChild(dismissWrapper);
            notificationElem.classList.add("notyf__toast--dismissible");
            dismissButton.addEventListener("click", function(event) {
                var _a, _b;
                (_b = (_a = _this.events)[$0381a95d2c185104$export$776308576d349339.Dismiss]) === null || _b === void 0 || _b.call(_a, {
                    target: notification,
                    event: event
                });
                event.stopPropagation();
            });
        }
        notificationElem.addEventListener("click", function(event) {
            var _a, _b;
            return (_b = (_a = _this.events)[$0381a95d2c185104$export$776308576d349339.Click]) === null || _b === void 0 ? void 0 : _b.call(_a, {
                target: notification,
                event: event
            });
        });
        // Adjust margins depending on whether its an upper or lower notification
        var className = this.getYPosition(options) === "top" ? "upper" : "lower";
        notificationElem.classList.add("notyf__toast--" + className);
        return notificationElem;
    };
    NotyfView.prototype._createHTMLElement = function(_a) {
        var tagName = _a.tagName, className = _a.className, text = _a.text;
        var elem = document.createElement(tagName);
        if (className) elem.className = className;
        elem.textContent = text || null;
        return elem;
    };
    /**
     * Creates an invisible container which will announce the notyfs to
     * screen readers
     */ NotyfView.prototype._createA11yContainer = function() {
        var a11yContainer = this._createHTMLElement({
            tagName: "div",
            className: "notyf-announcer"
        });
        a11yContainer.setAttribute("aria-atomic", "true");
        a11yContainer.setAttribute("aria-live", "polite");
        // Set the a11y container to be visible hidden. Can't use display: none as
        // screen readers won't read it.
        a11yContainer.style.border = "0";
        a11yContainer.style.clip = "rect(0 0 0 0)";
        a11yContainer.style.height = "1px";
        a11yContainer.style.margin = "-1px";
        a11yContainer.style.overflow = "hidden";
        a11yContainer.style.padding = "0";
        a11yContainer.style.position = "absolute";
        a11yContainer.style.width = "1px";
        a11yContainer.style.outline = "0";
        document.body.appendChild(a11yContainer);
        this.a11yContainer = a11yContainer;
    };
    /**
     * Announces a message to screenreaders.
     */ NotyfView.prototype._announce = function(message) {
        var _this = this;
        this.a11yContainer.textContent = "";
        // This 100ms timeout is necessary for some browser + screen-reader combinations:
        // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
        // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
        //   second time without clearing and then using a non-zero delay.
        // (using JAWS 17 at time of this writing).
        // https://github.com/angular/material2/blob/master/src/cdk/a11y/live-announcer/live-announcer.ts
        setTimeout(function() {
            _this.a11yContainer.textContent = message;
        }, 100);
    };
    /**
     * Determine which animationend event is supported
     */ NotyfView.prototype._getAnimationEndEventName = function() {
        var el = document.createElement("_fake");
        var transitions = {
            MozTransition: "animationend",
            OTransition: "oAnimationEnd",
            WebkitTransition: "webkitAnimationEnd",
            transition: "animationend"
        };
        var t;
        for(t in transitions){
            if (el.style[t] !== undefined) return transitions[t];
        }
        // No supported animation end event. Using "animationend" as a fallback
        return "animationend";
    };
    return NotyfView;
}();
/**
 * Main controller class. Defines the main Notyf API.
 */ var $0381a95d2c185104$export$146ebdf5fc143718 = /** @class */ function() {
    function Notyf(opts) {
        var _this = this;
        this.dismiss = this._removeNotification;
        this.notifications = new $0381a95d2c185104$export$7763ebb8bf460cea();
        this.view = new $0381a95d2c185104$export$75d30b0f81ca0e5f();
        var types = this.registerTypes(opts);
        this.options = $0381a95d2c185104$var$__assign($0381a95d2c185104$var$__assign({}, $0381a95d2c185104$export$93ca5d3f8675ae4c), opts);
        this.options.types = types;
        this.notifications.onUpdate(function(elem, type) {
            return _this.view.update(elem, type);
        });
        this.view.on($0381a95d2c185104$export$776308576d349339.Dismiss, function(_a) {
            var target = _a.target, event = _a.event;
            _this._removeNotification(target);
            // tslint:disable-next-line: no-string-literal
            target["triggerEvent"]($0381a95d2c185104$export$776308576d349339.Dismiss, event);
        });
        // tslint:disable-next-line: no-string-literal
        this.view.on($0381a95d2c185104$export$776308576d349339.Click, function(_a) {
            var target = _a.target, event = _a.event;
            return target["triggerEvent"]($0381a95d2c185104$export$776308576d349339.Click, event);
        });
    }
    Notyf.prototype.error = function(payload) {
        var options = this.normalizeOptions("error", payload);
        return this.open(options);
    };
    Notyf.prototype.success = function(payload) {
        var options = this.normalizeOptions("success", payload);
        return this.open(options);
    };
    Notyf.prototype.open = function(options) {
        var defaultOpts = this.options.types.find(function(_a) {
            var type = _a.type;
            return type === options.type;
        }) || {};
        var config = $0381a95d2c185104$var$__assign($0381a95d2c185104$var$__assign({}, defaultOpts), options);
        this.assignProps([
            "ripple",
            "position",
            "dismissible"
        ], config);
        var notification = new $0381a95d2c185104$export$1efaef7de3802058(config);
        this._pushNotification(notification);
        return notification;
    };
    Notyf.prototype.dismissAll = function() {
        while(this.notifications.splice(0, 1));
    };
    /**
     * Assigns properties to a config object based on two rules:
     * 1. If the config object already sets that prop, leave it as so
     * 2. Otherwise, use the default prop from the global options
     *
     * It's intended to build the final config object to open a notification. e.g. if
     * 'dismissible' is not set, then use the value from the global config.
     *
     * @param props - properties to be assigned to the config object
     * @param config - object whose properties need to be set
     */ Notyf.prototype.assignProps = function(props, config) {
        var _this = this;
        props.forEach(function(prop) {
            // intentional double equality to check for both null and undefined
            config[prop] = config[prop] == null ? _this.options[prop] : config[prop];
        });
    };
    Notyf.prototype._pushNotification = function(notification) {
        var _this = this;
        this.notifications.push(notification);
        var duration = notification.options.duration !== undefined ? notification.options.duration : this.options.duration;
        if (duration) setTimeout(function() {
            return _this._removeNotification(notification);
        }, duration);
    };
    Notyf.prototype._removeNotification = function(notification) {
        var index = this.notifications.indexOf(notification);
        if (index !== -1) this.notifications.splice(index, 1);
    };
    Notyf.prototype.normalizeOptions = function(type, payload) {
        var options = {
            type: type
        };
        if (typeof payload === "string") options.message = payload;
        else if (typeof payload === "object") options = $0381a95d2c185104$var$__assign($0381a95d2c185104$var$__assign({}, options), payload);
        return options;
    };
    Notyf.prototype.registerTypes = function(opts) {
        var incomingTypes = (opts && opts.types || []).slice();
        var finalDefaultTypes = $0381a95d2c185104$export$93ca5d3f8675ae4c.types.map(function(defaultType) {
            // find if there's a default type within the user input's types, if so, it means the user
            // wants to change some of the default settings
            var userTypeIdx = -1;
            incomingTypes.forEach(function(t, idx) {
                if (t.type === defaultType.type) userTypeIdx = idx;
            });
            var userType = userTypeIdx !== -1 ? incomingTypes.splice(userTypeIdx, 1)[0] : {};
            return $0381a95d2c185104$var$__assign($0381a95d2c185104$var$__assign({}, defaultType), userType);
        });
        return finalDefaultTypes.concat(incomingTypes);
    };
    return Notyf;
}();

});

parcelRegister("4HRPq", function(module, exports) {

$parcel$export(module.exports, "INOTIFYOPTIONS", function () { return $36d4eec9b22e9454$export$3f56b780a80dcd80; });
$parcel$export(module.exports, "QUILLMINIMAL", function () { return $36d4eec9b22e9454$export$240e4485d72f5b4e; });
$parcel$export(module.exports, "NOTE_TITLE_LIMIT", function () { return $36d4eec9b22e9454$export$1be8c9395db43b9b; });
$parcel$export(module.exports, "NOTE_DESCRIPTION_LIMIT", function () { return $36d4eec9b22e9454$export$5301cce93579062b; });
$parcel$export(module.exports, "TODO_TITLE_LIMIT", function () { return $36d4eec9b22e9454$export$202853bc628c98c7; });
$parcel$export(module.exports, "NOTESUCESS", function () { return $36d4eec9b22e9454$export$c1280595736bf572; });
$parcel$export(module.exports, "TODOSUCESS", function () { return $36d4eec9b22e9454$export$40940b9c33388522; });
$parcel$export(module.exports, "EVENTSUCCESS", function () { return $36d4eec9b22e9454$export$4b22566567bbb5d6; });
$parcel$export(module.exports, "SUCCESSUPDATE", function () { return $36d4eec9b22e9454$export$e45321636a194a9a; });
$parcel$export(module.exports, "FAILEDMESSAGE", function () { return $36d4eec9b22e9454$export$36ffa4b10e71942a; });
$parcel$export(module.exports, "NOCOMPLETEDTASK", function () { return $36d4eec9b22e9454$export$c60c757a22837bdc; });
$parcel$export(module.exports, "NOIMPORTANTTASK", function () { return $36d4eec9b22e9454$export$1a7d56787008644b; });
$parcel$export(module.exports, "EMPTYTASK", function () { return $36d4eec9b22e9454$export$63af7a20c8ab639a; });
$parcel$export(module.exports, "ITEMSDELETED", function () { return $36d4eec9b22e9454$export$1bc4a4cdeb833492; });
$parcel$export(module.exports, "LISTDELETECONFIRM", function () { return $36d4eec9b22e9454$export$e38a12d391799cf0; });
var $36d4eec9b22e9454$export$3f56b780a80dcd80 = {
    duration: 3000,
    position: {
        x: "right",
        y: "top"
    }
};
var $36d4eec9b22e9454$export$9d68c9423d2aefec = [
    [
        "bold",
        "italic",
        "underline",
        "strike"
    ],
    [
        "blockquote",
        "code-block"
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        }
    ],
    [
        {
            list: "ordered"
        },
        {
            list: "bullet"
        }
    ],
    [
        {
            script: "sub"
        },
        {
            script: "super"
        }
    ],
    [
        {
            indent: "-1"
        },
        {
            indent: "+1"
        }
    ],
    [
        {
            direction: "rtl"
        }
    ],
    [
        {
            size: [
                "small",
                false,
                "large",
                "huge"
            ]
        }
    ],
    [
        {
            header: [
                1,
                2,
                3,
                4,
                5,
                6,
                false
            ]
        }
    ],
    [
        {
            font: []
        }
    ],
    [
        "clean"
    ]
];
var $36d4eec9b22e9454$export$240e4485d72f5b4e = [
    [
        {
            header: [
                1,
                2,
                false
            ]
        }
    ],
    [
        "bold",
        "italic",
        "underline"
    ],
    [
        {
            list: "ordered"
        },
        {
            list: "bullet"
        },
        {
            indent: "-1"
        },
        {
            indent: "+1"
        },
        "code-block"
    ]
];
var $36d4eec9b22e9454$export$f2512d20085329c2 = 100;
var $36d4eec9b22e9454$export$c159fa2f4b7f4c29 = 500;
var $36d4eec9b22e9454$export$1be8c9395db43b9b = 25;
var $36d4eec9b22e9454$export$5301cce93579062b = 100;
var $36d4eec9b22e9454$export$202853bc628c98c7 = 33;
var $36d4eec9b22e9454$export$ac93d7dce274932b = 100;
var $36d4eec9b22e9454$export$c1280595736bf572 = "Note was created successfully";
var $36d4eec9b22e9454$export$40940b9c33388522 = "Task was created successfully";
var $36d4eec9b22e9454$export$4b22566567bbb5d6 = "Event was created successfully";
var $36d4eec9b22e9454$export$e45321636a194a9a = "data updated successfully";
var $36d4eec9b22e9454$export$36ffa4b10e71942a = "Something went wrong";
var $36d4eec9b22e9454$export$c60c757a22837bdc = "No Completed Task Yet.";
var $36d4eec9b22e9454$export$1a7d56787008644b = "No Marked Important Task Yet.";
var $36d4eec9b22e9454$export$63af7a20c8ab639a = "Empty Tasks, Add a new Task!";
var $36d4eec9b22e9454$export$1bc4a4cdeb833492 = "Item(s) was deleted successfully";
var $36d4eec9b22e9454$export$e38a12d391799cf0 = "If you delete the list it will be gone forever. Are you sure you want to proceed?";

});



var $d8bbfce8f9c47b43$exports = {};


(parcelRequire("hS6sa")).register((parcelRequire("iKXx1")).getBundleURL("hv1l8"), JSON.parse('["hv1l8","index.072b5dc7.js","65kCE","emptypage.dadd159b.gif","4qOEF","scrumboard.48256f97.css"]'));


var $1K4o4 = parcelRequire("1K4o4");

var $e2996 = parcelRequire("e2996");

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $8EGc6 = parcelRequire("8EGc6");

var $dACZV = parcelRequire("dACZV");

var $jhb1H = parcelRequire("jhb1H");

var $gAasq = parcelRequire("gAasq");

var $gpGF7 = parcelRequire("gpGF7");
var $4ec6c5aaddacdd87$exports = {};

$4ec6c5aaddacdd87$exports = (parcelRequire("iKXx1")).getBundleURL("hv1l8") + "emptypage.dadd159b.gif";



var $ev0Km = parcelRequire("ev0Km");

var $2B8he = parcelRequire("2B8he");

var $4HRPq = parcelRequire("4HRPq");
var $94b84dec75d69573$var$Timeline = /*#__PURE__*/ function(appView) {
    "use strict";
    (0, $dACZV._)(Timeline, appView);
    var _super = (0, $jhb1H._)(Timeline);
    function Timeline() {
        (0, $5kWiG._)(this, Timeline);
        var _this;
        _this = _super.call(this);
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_noteTimeline", document.querySelector("#noteTimeline").querySelector(".timeline-line"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_todoTimeline", document.querySelector("#todoTimeline").querySelector(".timeline-line"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_eventTimeline", document.querySelector("#eventTimeline").querySelector(".timeline-line"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_scrumTimeline", document.querySelector("#scrumTimeline").querySelector(".timeline-line"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_timelineAlert", document.querySelector(".alert-arrow-right"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_emptyPage", function(element) {
            var markup = '\n      <div class="empty-image">\n        <img\n          class="image-none"\n          src="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($4ec6c5aaddacdd87$exports))), '"\n          alt=""\n        />\n      </div>\n  ');
            element.insertAdjacentHTML("beforeend", markup);
        });
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_generateTimelineMarkup", function(data, element) {
            var timeDigits = this.formatTime(data.timestamp);
            var timeAgo = this.relativeTime(data.timestamp);
            var timeFormat = {
                timeDigits: timeDigits,
                timeAgo: timeAgo
            };
            var markup = (0, $ev0Km.default).timeLineMarkup(data, timeFormat);
            element.insertAdjacentHTML("beforeend", markup);
        });
        _this.initialize();
        return _this;
    }
    (0, $hHaEF._)(Timeline, [
        {
            key: "initialize",
            value: function initialize() {
                var _this = this;
                return (0, $e2996._)(function() {
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._LoadTimeline()
                                ];
                            case 1:
                                _state.sent();
                                _this._loadTodo();
                                _this._loadEvents();
                                _this._loadScrum();
                                _this._loadNotes();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_displayEmptyText",
            value: function _displayEmptyText(messageEl, message) {
                this._timelineAlert.style.display = "block";
                messageEl.textContent = message;
            }
        },
        {
            key: "_hideEmptyText",
            value: function _hideEmptyText(messageEl, message) {
                this._timelineAlert.style.display = "none";
                messageEl.textContent = message;
            }
        },
        {
            key: "_loadTodo",
            value: function _loadTodo() {
                var self = this;
                $("#pills-todo-tab").on("click", function() {
                    var _ref = (0, $e2996._)(function(e) {
                        var emptyText, filterFunction, data, sortedData, first10Items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, todo, newData, err;
                        return (0, $gAasq.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    emptyText = document.getElementById("todoTimeline").querySelector(".empty-text");
                                    filterFunction = function(item) {
                                        return item.completed === 0;
                                    };
                                    return [
                                        4,
                                        $gpGF7.getAllItemsFromDatabase("todo", filterFunction)
                                    ];
                                case 2:
                                    data = _state.sent();
                                    sortedData = self.sortDataByTimestamp(data);
                                    first10Items = sortedData.slice(0, 10);
                                    if (first10Items.length === 0) {
                                        self._todoTimeline.innerHTML = "";
                                        self._displayEmptyText(emptyText, "Empty Lists");
                                        self._emptyPage(self._todoTimeline);
                                    } else {
                                        self._todoTimeline.innerHTML = "";
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(_iterator = first10Items[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                todo = _step.value;
                                                newData = {
                                                    title: todo.title,
                                                    tag: todo.priority,
                                                    timestamp: todo.timestamp
                                                };
                                                self._hideEmptyText(emptyText, "Get Things Done");
                                                self._generateTimelineMarkup(newData, self._todoTimeline);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                    _iterator["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    err = _state.sent();
                                    self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "_loadNotes",
            value: function _loadNotes() {
                var self = this;
                $("#pills-notes-tab").on("click", function() {
                    var _ref = (0, $e2996._)(function(e) {
                        return (0, $gAasq.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    return [
                                        4,
                                        self._LoadTimeline()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "_formatNotesTag",
            value: function _formatNotesTag(note) {
                var tag;
                if (note === "note-personal") tag = "success";
                else if (note === "note-work") tag = "warning";
                else if (note === "note-social") tag = "info";
                else tag = "danger";
                return tag;
            }
        },
        {
            key: "_LoadTimeline",
            value: function _LoadTimeline() {
                var _this = this;
                return (0, $e2996._)(function() {
                    var emptyText, data, sortedData, first10Items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, note, newData, err1;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                emptyText = document.getElementById("noteTimeline").querySelector(".empty-text");
                                return [
                                    4,
                                    $gpGF7.getAllItemsFromDatabase("notes")
                                ];
                            case 1:
                                data = _state.sent();
                                sortedData = _this.sortDataByTimestamp(data);
                                first10Items = sortedData.slice(0, 10);
                                if (first10Items.length === 0) {
                                    _this._noteTimeline.innerHTML = "";
                                    _this._displayEmptyText(emptyText, "Empty Notes");
                                    _this._emptyPage(_this._noteTimeline);
                                } else {
                                    _this._noteTimeline.innerHTML = "";
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = first10Items[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            note = _step.value;
                                            newData = {
                                                title: note.title,
                                                tag: _this._formatNotesTag(note.tag),
                                                timestamp: note.timestamp
                                            };
                                            _this._hideEmptyText(emptyText, "Quick Notes");
                                            _this._generateTimelineMarkup(newData, _this._noteTimeline);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                _iterator["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err1 = _state.sent();
                                _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_formatEventsTag",
            value: function _formatEventsTag(event) {
                var tag;
                if (event === "Personal") tag = "success";
                else if (event === "Travel") tag = "warning";
                else if (event === "Work") tag = "primary";
                else tag = "danger";
                return tag;
            }
        },
        {
            key: "_loadEvents",
            value: function _loadEvents() {
                var self = this;
                $("#pills-event-tab").on("click", function() {
                    var _ref = (0, $e2996._)(function(e) {
                        var emptyText, data, currentDate, proximityThreshold, filteredData, first10Items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, event, newData, err1;
                        return (0, $gAasq.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    emptyText = document.getElementById("eventTimeline").querySelector(".empty-text");
                                    return [
                                        4,
                                        $gpGF7.getAllItemsFromDatabase("event")
                                    ];
                                case 2:
                                    data = _state.sent();
                                    currentDate = new Date();
                                    proximityThreshold = 432000000;
                                    filteredData = data.filter(function(item) {
                                        var eventStartDate = new Date(item.start);
                                        var timeDifference = eventStartDate.getTime() - currentDate.getTime();
                                        return timeDifference >= 0 && timeDifference <= proximityThreshold;
                                    });
                                    first10Items = filteredData.slice(0, 10);
                                    if (first10Items.length === 0) {
                                        self._eventTimeline.innerHTML = "";
                                        self._displayEmptyText(emptyText, "Empty Events");
                                        self._emptyPage(self._eventTimeline);
                                    } else {
                                        self._eventTimeline.innerHTML = "";
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(_iterator = first10Items[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                event = _step.value;
                                                newData = {
                                                    title: event.title,
                                                    tag: self._formatEventsTag(event.extendedProps.calendar),
                                                    timestamp: event.timestamp,
                                                    startdate: event.start.split("T")[0]
                                                };
                                                self._hideEmptyText(emptyText, "Upcoming Events");
                                                self._generateTimelineMarkup(newData, self._eventTimeline);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                    _iterator["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    err1 = _state.sent();
                                    self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "_formatScrumTag",
            value: function _formatScrumTag(scrum) {
                var tag;
                if (scrum === "s-in-progress") tag = "success";
                else if (scrum === "s-new") tag = "primary";
                else tag = "warning";
                return tag;
            }
        },
        {
            key: "_loadScrum",
            value: function _loadScrum() {
                var self = this;
                $("#pills-scrum-tab").on("click", function() {
                    var _ref = (0, $e2996._)(function(e) {
                        var emptyText, data, sortedData, first10Items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, scrum, newData, err1;
                        return (0, $gAasq.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    emptyText = document.getElementById("scrumTimeline").querySelector(".empty-text");
                                    return [
                                        4,
                                        $gpGF7.getAllItemsFromDatabase("scrumboard")
                                    ];
                                case 2:
                                    data = _state.sent();
                                    sortedData = self.sortDataByTimestamp(data);
                                    first10Items = sortedData.slice(0, 10);
                                    if (first10Items.length === 0) {
                                        self._scrumTimeline.innerHTML = "";
                                        self._displayEmptyText(emptyText, "Empty Tasks");
                                        self._emptyPage(self._scrumTimeline);
                                    } else {
                                        self._scrumTimeline.innerHTML = "";
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(_iterator = first10Items[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                scrum = _step.value;
                                                newData = {
                                                    title: scrum.title,
                                                    tag: self._formatScrumTag(scrum.tasksection),
                                                    timestamp: scrum.timestamp
                                                };
                                                self._hideEmptyText(emptyText, "Organize Tasks");
                                                self._generateTimelineMarkup(newData, self._scrumTimeline);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                    _iterator["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    err1 = _state.sent();
                                    self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    ]);
    return Timeline;
}((0, $2B8he.default));
new $94b84dec75d69573$var$Timeline();


//# sourceMappingURL=index.072b5dc7.js.map
